import { SingleMessage } from "@moe/priv/model/message";
import { useServiceContext } from "@web/route-services/chat/service-context";
import { useAppContext } from "@web/route-services/root/AppContext";

interface Props {
  message: SingleMessage;
  editText: string;
}

export function EditingHint({ message, editText }: Props) {
  const { service } = useServiceContext();
  const { isDesktopScreen } = useAppContext();

  const cancelDescription = isDesktopScreen ? "escape to" : "press to";
  const saveDescription = isDesktopScreen ? "enter to" : "press to";

  return (
    <div className="flex items-center rounded p-2">
      <span className="whitespace-nowrap">{cancelDescription}</span>
      <span
        onClick={() => {
          service.cancelEdit();
        }}
        className="white cursor-pointer p-2 font-bold text-[#3f42f8] transition duration-300 ease-out hover:scale-105 hover:brightness-125"
      >
        cancel
      </span>
      <span className="mx-2">•</span>
      <span className="">{saveDescription}</span>
      <span
        className="cursor-pointer p-2 font-bold text-[#3f42f8] transition duration-300 ease-out hover:scale-105 hover:brightness-125"
        onClick={() => {
          service.submitEdit(message, editText);
        }}
      >
        save
      </span>
    </div>
  );
}
